export const ASSET_TYPE = Object.freeze({
    OBJECT3D: 1,
    EMAIL: 2,
    URL: 3,
    PHONE: 4,
    VIDEO: 5,
    IMAGE: 6,
    WEBVIEW: 7,
    AUDIO: 9,
    VCARD: 10,
    FACEBOOK: 11,
    TWITTER: 12,
    SHARE: 13,
    AGENDA: 14,
    FILE: 15,
    VIDEOSTREAMING: 17
});

export interface BearAsset {
    id: number;
    page_id: number;
    asset_type: number;
    asset_subtype: number;
    x: number;
    y: number;
    z: number;
    width: number;
    height: number;
    s1: string;
    custom_image: string;
    custom_image_media: string;
    media_custom_image: string;
    media_file: string;
    scale: number;
    scale_android: number;
    alpha: number;
    theta: number;
    psi: number;
    is_transparent: boolean;
    name: string;
    zorder: number;
    is_instant_fullscreen: boolean;
    url: string;
    is_active: boolean;
    key_color: number;
    autoplay_on_texture: boolean;
    language_id: number;
    userId: number;
    is_play_in_loop: boolean;
    is_alpha_channel_video: boolean;
    meta: string;
    source: string;
    //additionnal values, TODO add them in another object
    sId: number; // id from scene
    domElement: HTMLVideoElement | HTMLImageElement;
    type_name: string;
    //for custom interaction
    target: string;
    action: string;
    videoUrl: string;
    targetUrl: string;
}
